/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationDto
 */
export interface UpdateOrganizationDto {
    /**
     * 組織名
     * @type {string}
     * @memberof UpdateOrganizationDto
     */
    name: string;
}

/**
 * Check if a given object implements the UpdateOrganizationDto interface.
 */
export function instanceOfUpdateOrganizationDto(value: object): value is UpdateOrganizationDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdateOrganizationDtoFromJSON(json: any): UpdateOrganizationDto {
    return UpdateOrganizationDtoFromJSONTyped(json, false);
}

export function UpdateOrganizationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UpdateOrganizationDtoToJSON(json: any): UpdateOrganizationDto {
    return UpdateOrganizationDtoToJSONTyped(json, false);
}

export function UpdateOrganizationDtoToJSONTyped(value?: UpdateOrganizationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

